/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/

import { useContext } from "react";
import { UseHandlerContext, UseStateContext } from "./AccordionContainer";

type useAccordionType = {
	data: DesignStuff.Accordion.State["data"];
	handleSelectAccordion: DesignStuff.Accordion.SelectHandler<string>;
};

export default function useAccordion(): useAccordionType {
	const { data } = useContext(UseStateContext);
	const handleSelectAccordion = useContext(UseHandlerContext);

	if (!handleSelectAccordion) throw new Error("not found UseHandlerContext => 캐쉬를 한번 지워주세요.");

	return { data, handleSelectAccordion };
}
